import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useDefaultQuoteItem from '@hooks/useDefaultQuoteItem'
import useDefaultQuoteItems from '@hooks/useDefaultQuoteItems'

import DefaultQuoteItemListItem from '../DefaultQuoteItemListItem'

const DefaultQuoteItems = () => {
  const selectedAgencyPayload = useAgencySelector()
  const { selectedAgencyId } = selectedAgencyPayload

  const defaultQuoteItemsPayload = useDefaultQuoteItems({
    filters: {
      owner_id: selectedAgencyId,
      owner_type: 'Agency',
    },
    performHttpRequests: true,
    requestOptions: {
      include_default_quote_item_provider: true,
    },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredDefaultQuoteItems,
    filteredDefaultQuoteItemsCount,
    hasFilteredDefaultQuoteItems,
    loading,
  } = defaultQuoteItemsPayload

  const defaultQuoteItemPayload = useDefaultQuoteItem({
    owner_id: selectedAgencyId,
    owner_type: 'Agency',
  })

  const {
    callbacks: {
      newDefaultQuoteItem,
    },
  } = defaultQuoteItemPayload

  return (
    <DashboardModule
      boxProps={{ borderBottom: loading && !hasFilteredDefaultQuoteItems ? 'none' : undefined }}
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Default Quote Items"
    >
      {!loading && !!hasFilteredDefaultQuoteItems && (
        <DashboardModule.ScrollableSection>
          {filteredDefaultQuoteItems.map(item => (
            <DefaultQuoteItemListItem
              defaultQuoteItem={item}
              key={item.id}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredDefaultQuoteItems && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            You don&apos;t have any default quote items.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredDefaultQuoteItemsCount}
        loading={loading}
        showBorderTop={!loading}
      >
        {!loading && (
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlusCircle} />}
            onClick={() => newDefaultQuoteItem()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Item
          </Button>
        )}
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default DefaultQuoteItems
